import React, { Component } from 'react';
import Button from '../../artzu-ui/src/Button'
import TextField from '../../artzu-ui/src/TextField'
import { Mutation } from 'react-apollo'
import gql from 'graphql-tag';
// import './profile.css';

class Footer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      
    }
  }
  render() {
    const { amount, label, action } = this.props;
    return (
      <Mutation
        mutation={CHARGE_CARD}
        onCompleted={async ({ chargeCard }) => {

        }}
      >
        {chargeCard => (
          <div className="payment-footer">
            <Button
              label={label}
              className="submit-action"
              padding="0"
              onClick={label === "Pay" ? () => {
                chargeCard()
              } : action}
            />
          </div>
        )}
      </Mutation>
    );
  }
}

const CHARGE_CARD = gql`
  mutation chargeCard($card_id: Int!, $amount: Float!) {
    chargeCard(card_id: $card_id, amount: $amount) {
      transaction {
        amount
      }
      errors
    }
  }
`;

export default Footer;



// WEBPACK FOOTER //
// ./src/components/NewPayments/Footer.js